<div *ngIf="group" class="content-panel" style="padding: 0 10px">
  <div class="scrollable">
    <h2 class="group-name">{{ group.name }}</h2>
    <p class="apply-template">
      <a (click)="applyTemplate(); $event.stopPropagation()">Apply template</a>
    </p>
    <br />
    <form [formGroup]="form" class="form-scroll">
      <div class="form-group">
        <label for="name">Name</label>
        <input type="text" class="form-control" formControlName="name" [ngClass]="getValidationClass('name')" />
        <p *ngIf="form.get('name').errors?.groupNameExists" class="text-danger">This group already exists</p>
      </div>

      <div class="form-group">
        <label for="name">Flag type</label>
        <select formControlName="type" class="form-control">
          <option
            *ngFor="let t of flagTypes"
            [ngValue]="t"
            [attr.disabled]="t.name == 'Legacy' ? true : null"
            [hidden]="t.name == 'Legacy'">
            {{ t.name }}
          </option>
        </select>
      </div>

      <div class="form-group" *ngIf="form.get('type').value?.name == 'Violation'">
        <label for="name">and subtype?</label>
        <select formControlName="subtype" class="form-control">
          <option *ngFor="let st of flagSubtypes" [ngValue]="st">{{ st?.name }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="name">Issue description</label>
        <input type="text" class="form-control" formControlName="description" />
      </div>

      <div *ngIf="form.get('type').value?.name == 'Violation'">
        <div formGroupName="violation">
          <div class="form-group">
            <label for="name">Elevated Risk</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="elevatedRisk"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">Why does this matter?</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="whyDoesThisMatter"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">Actions requested</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="actionRequested"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">Documentation requested</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="documentationRequested"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">Documentation pictures</label>
            <br />
            <button class="btn btn-primary" (click)="openDocPictures()">
              View/add pictures ({{ form.get('helpPictures')?.value?.length || 0 }})
            </button>
          </div>

          <div class="form-group">
            <label for="name" style="margin-bottom: 0">Deadline</label>
            <div *ngIf="false && !readOnly">
              <button (click)="setDeadline('+30d')" type="button" class="btn btn-sm btn-link" style="padding: 3px 10px">
                30 days
              </button>
              <button (click)="setDeadline('+60d')" type="button" class="btn btn-sm btn-link" style="padding: 3px 10px">
                60 days
              </button>
              <button (click)="setDeadline('+90d')" type="button" class="btn btn-sm btn-link" style="padding: 3px 10px">
                90 days
              </button>
            </div>
            <input formControlName="deadline" class="form-control" bsDatepicker [bsConfig]="dateConfig" />
          </div>

          <div class="form-group">
            <label for="name">Internal notes</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="internalNotes"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">URL Title</label>
            <input type="text" formControlName="urlTitle" class="form-control" />
          </div>

          <div class="form-group">
            <label for="name">URL</label>
            <input type="text" formControlName="url" class="form-control" />
          </div>
        </div>
      </div>

      <div *ngIf="form.get('type').value?.name == 'Discrepancy'">
        <div formGroupName="discrepancy">
          <div class="form-group">
            <label for="name">Application Stated</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="stated"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">Accurate Finding from Inspection</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="actual"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">Result of the findings</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="resultOfTheFinding"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">Impact</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="impact"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name" style="margin-bottom: 0">Effective date</label>
            <div *ngIf="!readOnly">
              <button
                (click)="setEffectiveDate('+30d')"
                type="button"
                class="btn btn-sm btn-link"
                style="padding: 3px 10px">
                30 days
              </button>
              <button
                (click)="setEffectiveDate('+60d')"
                type="button"
                class="btn btn-sm btn-link"
                style="padding: 3px 10px">
                60 days
              </button>
              <button
                (click)="setEffectiveDate('+90d')"
                type="button"
                class="btn btn-sm btn-link"
                style="padding: 3px 10px">
                90 days
              </button>
            </div>
            <input formControlName="effectiveDate" class="form-control" bsDatepicker [bsConfig]="dateConfig" />
          </div>

          <div class="form-group">
            <label for="name">Additional components for report</label>
            <app-markdown [toolbar]="[['ul']]" formControlName="commentsForReport"></app-markdown>
          </div>

          <div class="form-group">
            <label for="name">URL Title</label>
            <input type="text" formControlName="urlTitle" class="form-control" />
          </div>

          <div class="form-group">
            <label for="name">URL</label>
            <input type="text" formControlName="url" class="form-control" />
          </div>
        </div>
      </div>
    </form>
    <br />
  </div>

  <div class="content-footer" style="padding-top: 20px" *ngIf="!readOnly">
    <button [disabled]="form.invalid" type="button" class="btn aru btn-primary" (click)="save()">Save group</button>
    &nbsp;
    <button type="button" class="btn aru btn-ghost-danger" (click)="cancel.emit()">Cancel</button>
  </div>
  <br />
</div>

<div
  bsModal
  #helpPicturesModal="bs-modal"
  class="modal"
  tabindex="-1"
  role="dialog"
  [config]="{ backdrop: false }"
  aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-child-name" class="modal-title pull-left">Documentation Pictures</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="cancelHelpPictures()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 25px">
        <form style="padding: 10px">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div *ngIf="!form.get('helpPictures')?.value?.length" style="margin-bottom: 20px">
                  No images attached
                </div>
                <div *ngIf="form.get('helpPictures')?.value?.length" style="margin-bottom: 20px">
                  <div
                    *ngFor="let p of form.get('helpPictures').controls; let i = index"
                    style="display: inline-block; max-width: 250px; margin: 10px">
                    <div [formGroup]="p">
                      <span
                        style="
                          display: inline-block;
                          width: 240px;
                          box-shadow: 0px 0px 7px #000;
                          margin: 5px;
                          position: relative;
                        ">
                        <img-ajax [src]="getSrc(p.value)"></img-ajax>
                        <span style="position: absolute; left: 5px; top: 5px"
                          ><button type="button" class="btn btn-danger btn-sm" (click)="removeHelpPicture(i)">
                            X
                          </button></span
                        >
                      </span>
                      <br />
                      <input type="text" formControlName="title" placeholder="Title" class="form-control" />
                      <app-markdown id="optionEditor" formControlName="caption" [options]="{ height: 150 }">
                      </app-markdown>
                    </div>
                  </div>
                </div>
                <input type="file" (change)="setUploadFile($event.target.files)" #fileHelpPicture />
                <button
                  type="button"
                  class="btn btn-primary aru"
                  (click)="uploadHelpPicture(fileHelpPicture)"
                  [disabled]="!fileHelpPicture.value">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </form>
        <button type="button" class="btn btn-primary aru" (click)="closeHelpPictures()">Confirm</button>
        <button type="button" class="btn btn-default aru" (click)="cancelHelpPictures()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<app-flag-group-template
  #flagGroupTemplateModal
  [group]="this.form.value"
  [flagGroupTags]="flagGroupTags"
  [expand]="true"
  (editGroup)="editGroupByTemplate($event)"
  (messageEvent)="updateData($event)"></app-flag-group-template>
